import Title from "./UI/Title";
import PageContent from "./UI/PageContent";
import bump from "../img/bump.png";
import snowball from "../img/snowball-xyz-fintech-b2c.png"
import majelan from "../img/majelan-1.png";
import project1 from "../img/project-1.png";
import project2 from "../img/project-2.png";
import khloros from "../img/khloros.png";
import { ReactComponent as Typescript } from "../img/typescript.svg";
import { ReactComponent as ReactIcon } from "../img/react.svg";
import { ReactComponent as Css } from "../img/css.svg";
import { ReactComponent as Net } from "../img/net.svg";
import { ReactComponent as Next } from "../img/next.svg";
import { ReactComponent as Postgres } from "../img/postgres.svg";

const PROJECTS = [
    {
    title: "Snowball.xyz",
    img: snowball,
    description:
      "Built B2C applications for Finance Media and a personal wealth management app, using TypeScript, React, Next.js, Tailwind CSS, Clerk, and more.",
    icons: [Typescript, ReactIcon, Next],
  },
  {
    title: "Bump Charge",
    img: bump,
    description:
      "B2B platform for electrical fleet vehicle management. Stack : Typescript, React, Next.js, GraphQL, .Net, PostgresSQL, EFCore, Elastic Search...",
    icons: [Typescript, ReactIcon, Next, Net, Postgres],
  },
  {
    title: "Majelan",
    img: majelan,
    description:
      "B2C Podcast platform. Stack : Typescript, React, Next.js, React Native, React Query, Firebase, Tailwind...",
    icons: [Typescript, ReactIcon, Next, Css],
  },
  {
    title: "Designer Portfolio",
    img: khloros,
    description:
      "Designer Portfolio in React, with CSS animations, Framer Motion, Swiper JS & scrolling animations",
    icons: [Typescript, ReactIcon, Css],
  },
  {
    title: "Movie DB Mobile App",
    img: project1,
    description:
      "Build with React Native CLI. Users can find movies by category, see movie details and launch trailers.",
    icons: [Typescript, ReactIcon],
  },
  {
    title: "Book Rating App",
    img: project2,
    description:
      "Neumorphism designed app to add books, comment & rate them. Build using ReactJS, Typescript & Firebase.",
    icons: [Typescript, ReactIcon, Css],
  },
];

function Portfolio() {
  return (
    <PageContent>
      <div className="section-stack">
        <div>
          <Title title="🚀 Portfolio" />
          <a
            href="https://github.com/Ed-Ls"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-4 text-muted hover:text-ink transition-colors"
          >
            Check <span className="underline">my github</span> for more
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {PROJECTS.map((project) => (
            <Card key={project.title} {...project} />
          ))}
        </div>
      </div>
    </PageContent>
  );
}

export default Portfolio;

export const Card = ({ title, description, icons, img }) => {
  return (
    <article className="glass-card p-6 flex flex-col gap-4 h-full">
      <div className="h-52 md:h-56 overflow-hidden rounded-2xl shrink-0">
        <img className="w-full h-full rounded-2xl object-cover" src={img} alt={title} />
      </div>
      <Title title={title} className="!text-2xl" />
      <p className="text-sm text-muted leading-relaxed flex-1">{description}</p>
      {icons?.length > 0 && (
        <div className="flex gap-2 border-t border-[#E7E7E7]/50 pt-4 mt-auto">
          {icons.map((Icon, i) => (
            <Icon key={i} className="w-6 h-6" />
          ))}
        </div>
      )}
    </article>
  );
};
